import classNames from 'classnames';
import renderInlineItalic from 'lib/utils/renderInlineItalic';
import ArrowLeft from 'components/shared/arrow-left';
import ArrowRight from 'components/shared/arrow-right';
import Image from 'components/shared/image';
import RichText from 'components/shared/richtext';
import useIsMobile from 'hooks/utils/useIsMobile';
import { useMemo, useRef, useState } from 'react';
import { useTranslations } from 'contexts';
import styles from './promises.module.scss';

const Promises = ({ data }) => {
  const translations = useTranslations();
  const { title, titleFont, subtext, promises, anchorId } = data;
  const titleClass = classNames(styles.promisesTitle, titleFont !== 'Acumin Pro' && styles.octave);
  const carouselRef = useRef();
  const isMobile = useIsMobile();
  const [carouselPositioning, setCarouselPositioning] = useState({
    atLeftSide: true,
    atRightSide: false,
  });
  const carouselItemWidth = useMemo(
    () => carouselRef.current?.children[0].children[1]?.clientWidth,
    [carouselRef.current]
  );

  const leftHandler = () => {
    carouselRef.current?.scrollBy({ left: -carouselItemWidth, behavior: 'smooth' });
  };
  const rightHandler = () => {
    carouselRef.current?.scrollBy({ left: carouselItemWidth, behavior: 'smooth' });
  };
  const updateCarouselPositioning = () => {
    setCarouselPositioning({
      atLeftSide: carouselRef.current?.scrollLeft === 0,
      atRightSide:
        carouselRef.current?.scrollLeft + window?.innerWidth >= carouselRef.current?.scrollWidth,
    });
  };

  let timeout;

  return (
    <section id={anchorId} className={styles.promisesSection}>
      <div className={styles.titleAndSubtextWrapper}>
        <h2 className={titleClass}>{renderInlineItalic(title)}</h2>
        <RichText className={styles.promisesSubtext} text={subtext?.json} />
      </div>
      <div
        className={styles.promisesCarouselWrapper}
        ref={carouselRef}
        onScroll={() => {
          clearTimeout(timeout);
          timeout = setTimeout(() => updateCarouselPositioning(), 200);
        }}
      >
        <div className={styles.promisesCarousel}>
          {!isMobile && (
            <>
              {!carouselPositioning.atLeftSide && (
                <button
                  type="button"
                  className={styles.carouselLeftButton}
                  onClick={() => leftHandler()}
                  aria-label={translations?.accessibility?.previous || 'Previous'}
                >
                  <ArrowLeft />
                </button>
              )}
              {!carouselPositioning.atRightSide && (
                <button
                  type="button"
                  className={styles.carouselRightButton}
                  onClick={() => rightHandler()}
                  aria-label={translations?.accessibility?.next || 'Next'}
                >
                  <ArrowRight />
                </button>
              )}
            </>
          )}
          {promises.map(promise => (
            <SinglePromise
              key={promise}
              title={promise.title}
              subText={promise.subtext}
              image={promise.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Promises;

const SinglePromise = ({ title, subText, image }) => (
  <div className={styles.singlePromiseWrapper}>
    <Image
      className={styles.singlePromiseImage}
      src={image.image}
      layout="fill"
      loading="lazy"
      sizes="(max-width: 899px) 100vw, 35vw"
    />
    <h3 className={styles.singlePromiseTitle}>{title}</h3>
    <p className={styles.singlePromiseSubtext}>{subText}</p>
  </div>
);
